module.exports = __webpack_public_path__ + "media/בלון.003c83be.mp3";